import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId } from 'src/client/spendesk-api';

export const useUpdateEntityTripMutation = ({
  entityType,
  entityId,
}: {
  entityType: 'requests' | 'payments' | 'payables';
  entityId: string;
}) => {
  const companyId = useCompanyId();

  return useMutation(
    [entityType, entityId, 'trip'],
    async (tripId: string) => {
      const response =
        await putV2ApiCompanyIdTravelEntityTypeEntityIdTripTripId({
          path: {
            companyId,
            entityType,
            entityId,
            tripId,
          },
        });

      if (response.statusCode !== 200) {
        throw new Error(`Failed to update trip for ${entityType} ${entityId}`);
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
